<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="nonindent">Names, places, even mountains change. But people remain. They are real. This story is just that, a story for anyone to read. The book, though, is for the people of North Korea, and especially for the little girl, crying in the field.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312352080_epub_ded_r1.vue?4ab86064